import React from 'react';
import { ClipboardList, MessageSquare } from 'lucide-react';
import { ResponsiveModal } from '../ui/ResponsiveModal';
import LeadNotesSection from './LeadNotesSection';

interface LeadNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  notesModalTab: 'notes' | 'tasks';
  setNotesModalTab: (tab: 'notes' | 'tasks') => void;
  selectedClient: any;
  notes: any[];
  activities: any[];
  notesLoading: boolean;
  translations: any;
  formatDate: (date: string) => string;
  onAddNote: (content: string) => Promise<void>;
  onAddTask: (task: any) => Promise<void>;
  onEditNote: (noteId: string, content: string) => Promise<void>;
  onDeleteNote: (noteId: string) => Promise<void>;
  onDeleteActivity: (activityId: string, opts?: { skipGoogleSync?: boolean }) => Promise<void>;
  onUpdateActivities: () => Promise<void>;
  toast: any;
  showSkeleton: boolean;
}

export function LeadNotesModal({
  isOpen,
  onClose,
  notesModalTab,
  setNotesModalTab,
  selectedClient,
  notes,
  activities,
  notesLoading,
  translations,
  formatDate,
  onAddNote,
  onAddTask,
  onEditNote,
  onDeleteNote,
  onDeleteActivity,
  onUpdateActivities,
  toast,
  showSkeleton
}: LeadNotesModalProps) {
  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title="Note e Task"
      size="xl"
      mobileHeight="90vh"
    >
      {/* Tab Navigation */}
      <div className="flex space-x-4 mb-4 border-b border-black/10 pb-2">
        <button
          onClick={() => setNotesModalTab('notes')}
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
            notesModalTab === 'notes'
              ? 'bg-blue-100 text-blue-700'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <MessageSquare className="h-4 w-4 mr-1.5 inline" />
          Note ({notes.length})
        </button>
        <button
          onClick={() => setNotesModalTab('tasks')}
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
            notesModalTab === 'tasks'
              ? 'bg-orange-100 text-orange-700'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <ClipboardList className="h-4 w-4 mr-1.5 inline" />
          Task ({activities.length})
        </button>
      </div>

          {/* Modal Content */}
          <div className="flex-1 overflow-hidden">
            <LeadNotesSection
              lead={selectedClient}
              leadNotes={notesModalTab === 'notes' ? notes : []}
              leadActivities={notesModalTab === 'tasks' ? activities : []}
              loadingNotes={notesLoading}
              translations={translations}
              formatDate={formatDate}
              onAddNote={onAddNote}
              onAddTask={onAddTask}
              onEditNote={onEditNote}
              onDeleteNote={onDeleteNote}
              onDeleteActivity={onDeleteActivity}
              onUpdateActivities={onUpdateActivities}
              toast={toast}
              loading={showSkeleton}
            />
          </div>
    </ResponsiveModal>
  );
}